var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"lazy-load"},[(_vm.isMounted)?_vm._t("default"):(_vm.config)?_c('img',{staticClass:"lazy-pic",attrs:{"src":_vm.config.prerender_pic,"alt":"Loading"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }